// extracted by mini-css-extract-plugin
export default {"AdhdTitle1":"iStyles_AdhdTitle1__LWu73","AdhdTitle2":"iStyles_AdhdTitle2__G1BZw","AdhdTitle3":"iStyles_AdhdTitle3__bVWpg"};